import React from 'react';
import {
	Typography,
	Card,
	Box,
	container,
	Grid,
	Paper,
	Button,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import Footer from './Foot'

const Contact = () => {
	return (
		<>
		<Box
			style={{
				width: '100%',
				background: '#2C73D2',
				margin: '0 auto',
				height: '100vh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<Paper
				square={true}
				style={{
					margin: '0 auto',
					display: 'flex',
					width: 'fit-content',
					justifyContent: 'center',
					alignItems: 'center',
					flexDirection: 'column',
					padding: '2em',
					// height:"50vh",
				}}
			>
				<Typography 
          variant="h4" 
          fontWeight="700" 
          fontSize='24px'
          fontFamily='epilogue'
          style={{marginBottom:'.74em', color:'hsl(0, 0%, 41%)'}}
        >
					Contact us
				</Typography>

				<form
					target="_blank"
					action="https://formsubmit.co/#"
					method="POST"
					style={{ background: '', width: '350px' }}
				>
					<div class="form-group">
						<div class="form-row">
							<div class="col">
								<input
									type="text"
									name="name"
									class="form-control"
									placeholder="Full Name"
									required
									style={{ width: '100%', height: '3em', marginBottom: '.5em' }}
								/>
							</div>
							<div class="col">
								<input
									type="email"
									name="email"
									class="form-control"
									placeholder="Email Address"
									required
									style={{ width: '100%', height: '3em', marginBottom: '.5em' }}
								/>
							</div>
						</div>
					</div>
					<div class="form-group">
						<textarea
							placeholder="Your Message"
							class="form-control"
							name="message"
							rows="10"
							required
							style={{ width: '100%', height: '10em', marginBottom: '1em' }}
						></textarea>
					</div>
					<Button 
            variant="contained" 
            type="submit" 
            style={{fontFamily:"epilogue"}}
            endIcon={<SendIcon />}
          >
						Send
					</Button>
				</form>
			</Paper>
		</Box>
		<Footer />
		</>
	);
};

export default Contact;
